import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { DragDropContext } from 'react-beautiful-dnd'
import { CategoryDroppable } from 'registry/components/organize'
import { InfoButton } from 'components/buttons'

import { registryPath } from 'lib/urls'
import {
  getCategorizedRegItems,
  getIsFetchingCategorizedRegItems,
  getRegistryCategories,
} from 'registry/reducers'
import {
  fetchCategorizedRegItems,
  moveCategorizedRegItemToNewCategory,
  updateRegItemsPositions,
} from 'registry/actions/reg-items-actions'

class Organize extends PureComponent {
  componentDidMount() {
    if (!this.props.isFetchingCategorizedRegItems) {
      this.props.fetchCategorizedRegItems()
    }
  }

  onDragEnd = ({ source, destination }) => {
    const {
      updateRegItemsPositions,
      moveCategorizedRegItemToNewCategory,
      categorizedRegItems,
    } = this.props
    const sourceCategory = categorizedRegItems[source.droppableId]
    const activeRegItem = sourceCategory.regItems[source.index]
    const oldPosition = activeRegItem.position
    const oldCategoryId = activeRegItem.categoryId
    let newPosition = null

    // dropped outside the list
    if (!destination) {
      return
    }

    // dropped in same category
    if (source.droppableId === destination.droppableId) {
      newPosition = sourceCategory.regItems[destination.index].position
      updateRegItemsPositions(sourceCategory.id, oldPosition, newPosition)
    } else {
      // dropped in different category
      const destinationCategory = categorizedRegItems[destination.droppableId]
      const targetItem = destinationCategory.regItems[destination.index]
      // use position 0 if dropped at bottom of list
      // or position it above the item under the drop event
      newPosition = targetItem ? targetItem.position + 1 : 0
      moveCategorizedRegItemToNewCategory(
        activeRegItem,
        oldCategoryId,
        oldPosition,
        destinationCategory.id,
        newPosition
      )
    }
  }

  render() {
    const { categorizedRegItems, registryUrlSlug } = this.props

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        {categorizedRegItems.map((category, index) => (
          <CategoryDroppable category={category} index={index} />
        ))}
        {categorizedRegItems.length > 3 && (
          <div className="flex row center flex-grow">
            <Link to={registryPath(registryUrlSlug)}>
              <InfoButton align="center" size="small" empty pill>
                Done Organizing
              </InfoButton>
            </Link>
          </div>
        )}
      </DragDropContext>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  categories: getRegistryCategories(state),
  categorizedRegItems: getCategorizedRegItems(state),
  isFetchingCategorizedRegItems: getIsFetchingCategorizedRegItems(state),
})

export default connect(mapStateToProps, {
  moveCategorizedRegItemToNewCategory,
  updateRegItemsPositions,
  fetchCategorizedRegItems,
})(Organize)
